import Config from '../config/config.json';

export const HOME_LOGIN_URL = Config.server.basePath + Config.server.contextpath + Config.server.homeLoginPath;
export const POLICY_AUTHN_URL = Config.server.basePath + Config.server.contextpath + Config.server.policyAuthnPath;
export const AUTHN_TRIGGER_OTP_URL = Config.server.basePath + Config.server.contextpath + Config.server.triggerOTPPath;
export const SESSION_VALIDATION_URL = Config.server.basePath + Config.server.contextpath + Config.server.sessionValidatePath;
export const LOGOUT_URL = Config.server.basePath + Config.server.contextpath + Config.server.logoutPath;
export const FORGOT_PWD_INIT_URL = Config.server.basePath + Config.server.contextpath + "/forgot-pwd/token/generate";
export const CHANGE_PWD_INIT_URL = Config.server.basePath + Config.server.contextpath + Config.server.changePwdInitPath;

